// Minimum access code length accepted by the Join Flow. Keep in sync with the
// backend rule in catalog-api (Coupon::MIN_CODE_LENGTH).
export const MIN_COUPON_LENGTH = 5
